<template>
  <div class="flex justify-center items-center gap-2 py-4">
    <button
      @click="goToPreviousPage"
      :disabled="currentPage === 1"
      class="px-3 py-1.5 rounded-lg text-sm font-medium border border-gray-300 bg-white text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Previous
    </button>
    <button
      v-for="page in pagesToShow"
      :key="page"
      @click="goToPage(page)"
      :class="[
        'px-3 py-1.5 rounded-lg text-sm font-medium border transition',
        page === currentPage
          ? 'bg-ds-button-color text-white border-ds-button-color'
          : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100',
      ]"
    >
      {{ page }}
    </button>
    <button
      @click="goToNextPage"
      :disabled="currentPage === totalPages"
      class="px-3 py-1.5 rounded-lg text-sm font-medium border border-gray-300 bg-white text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Next
    </button>
  </div>
</template>

<script>
import { computed } from "vue";
export default {
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true },
  },
  emits: ["update:page"],
  setup(props, { emit }) {
    const goToPage = (page) => {
      if (page !== props.currentPage) emit("update:page", page);
    };

    const goToPreviousPage = () => {
      if (props.currentPage > 1) emit("update:page", props.currentPage - 1);
    };
    const goToNextPage = () => {
      if (props.currentPage < props.totalPages)
        emit("update:page", props.currentPage + 1);
    };

    const pagesToShow = computed(() => {
      const total = props.totalPages;
      const current = props.currentPage;
      const delta = 2;
      const range = [];
      for (
        let i = Math.max(1, current - delta);
        i <= Math.min(total, current + delta);
        i++
      ) {
        range.push(i);
      }
      return range;
    });

    return {
      goToPage,
      goToPreviousPage,
      goToNextPage,
      pagesToShow,
    };
  },
};
</script>
